import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Betslip} from '../betslip.js';

import {quickBetslipFactory} from './quick-betslip.factory';

import PALETTE_SCHEMA from './quick-betslip.palette-schema.yaml';

class QuickBetslipFeature extends AbstractVisualFeature {
    get name() {
        return 'QuickBetslip';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return quickBetslipFactory(PALETTE);
    }
}

new QuickBetslipFeature(Betslip);
